import React from "react";
import { useTranslation } from "react-i18next";

import ParentForm from "./parent-form";

const ParentsInformations = props => {
  const { t } = useTranslation();

  return (
    <div>
      <h4>{t("add_kid.parents_info.title")}</h4>
      <ParentForm {...props} index="0" />
      <ParentForm {...props} index="1" />
    </div>
  );
};

export default ParentsInformations;
